import React from 'react'
import classNames from 'classnames'
import { capitalize } from 'lodash'
import pluralize from 'pluralize'
import { IconArrowLeft, IconArrowRight } from '@tabler/icons-react'

import { Button } from '@/components/buttons/Button'
import { SearchableDropdown } from '@/components/dropdowns/SearchableDropdown'

import { getPageBeginning, getPageEnd } from './helpers'

import './AdvancedTablePagination.scss'

export const AdvancedTablePagination = ({
  activePage,
  rowsPerPage,
  count,
  totalPages,
  setActivePage,
  transparent,
  dataGrid,
  handleUpdateRowsPerPage,
  dropdownProps = {},
  label,
  ...props
}) => {
  const pageBeginning = getPageBeginning(activePage, rowsPerPage, count)
  const pageEnd = getPageEnd(activePage, totalPages, rowsPerPage, count, pageBeginning)

  const paginationLabel = label ? capitalize(pluralize(label)) : 'Rows'
  const paginationOptions = [10, 20, 30, 40, 50, 100].map((value) => ({
    value,
    label: `${value} ${paginationLabel} per Page`,
  }))

  return (
    <div
      className={classNames('advanced-table__pagination', { transparent, 'no-border': dataGrid })}
      data-testid="advanced-table-pagination"
      {...props}
    >
      <div className="advanced-table__pagination--details">
        {handleUpdateRowsPerPage && (
          <SearchableDropdown
            placement="top-start"
            hideSearch
            placeholder={`Select ${paginationLabel} per Page`}
            options={paginationOptions}
            selected={rowsPerPage}
            handleSelect={handleUpdateRowsPerPage}
            buttonProps={{ basic: true, small: true }}
            {...dropdownProps}
          />
        )}
        <div>{`${pageBeginning.toLocaleString()} – ${pageEnd.toLocaleString()} of ${count.toLocaleString()} ${label ? pluralize(label, count) : ''}`}</div>
      </div>
      <div className="advanced-table__pagination--arrows">
        <Button
          square
          small
          disabled={activePage === 1}
          data-testid="pagination-prev"
          onClick={() => activePage !== 1 && setActivePage((prevState) => prevState - 1)}
        >
          <IconArrowLeft />
        </Button>
        <Button
          square
          small
          data-testid="pagination-next"
          disabled={activePage === totalPages}
          onClick={() => activePage !== totalPages && setActivePage((prevState) => prevState + 1)}
        >
          <IconArrowRight />
        </Button>
      </div>
    </div>
  )
}
